export default __webpack_public_path__ + "static/media/V6.f3766a10.mp4";